import { GetExternalCallsTableFiltersActionTypes, GetExternalCallsTableFiltersState, SET_EXTERNAL_API_CALLS_TABLE_FILTERS } from 'store/reducers/external-api-call-log/get-external-calls-table-filters/types';

const defaultState: GetExternalCallsTableFiltersState = {
  isLoading: false,
  errorMessage: "",
  contents: { endpoints: '' },
  exists: false,
};

export default function externalCallsTableFilters(state = defaultState, action: GetExternalCallsTableFiltersActionTypes): GetExternalCallsTableFiltersState {
  switch (action.type) {
    case SET_EXTERNAL_API_CALLS_TABLE_FILTERS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        exists: action.exists,
      };
    default:
      return state;
  }
}
